import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Signup() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const u = await register(form);
      toast.success(`Welcome ${u.name}!`);
      nav("/menu", { replace: true });
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="signup-page">
      <div className="w-full max-w-md">
        <div className="label-eyebrow mb-3">Sign up</div>
        <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight mb-2">Create a customer account</h1>
        <p className="text-sm text-[var(--text-secondary)] mb-8">
          Sign up to order from the digital menu and earn loyalty points on every visit.
        </p>

        <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
          <div>
            <Label className="label-eyebrow">Full name</Label>
            <Input
              required value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="mt-1" data-testid="signup-name-input"
            />
          </div>
          <div>
            <Label className="label-eyebrow">Email</Label>
            <Input
              required type="email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="mt-1" data-testid="signup-email-input"
            />
          </div>
          <div>
            <Label className="label-eyebrow">Phone (optional)</Label>
            <Input
              value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })}
              className="mt-1" data-testid="signup-phone-input"
            />
          </div>
          <div>
            <Label className="label-eyebrow">Password</Label>
            <Input
              required minLength={6} type="password" value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1" data-testid="signup-password-input"
            />
          </div>
          {err && <div className="text-sm text-[var(--brand)] font-medium" data-testid="signup-error">{err}</div>}
          <Button type="submit" disabled={busy} className="w-full btn-primary h-11 rounded-md font-semibold" data-testid="signup-submit-btn">
            {busy ? "Creating…" : "Create account"}
          </Button>
        </form>

        <div className="mt-6 text-sm text-[var(--text-secondary)]">
          Already have an account?{" "}
          <Link to="/login" className="text-[var(--brand)] font-semibold hover:underline" data-testid="goto-login">
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
